import { MapfreLinkComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-link/mapfre-link.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreInfoDivsComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { PolicyErrorSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/policy-error-svg/policy-error-svg.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Router , RouterModule } from '@angular/router';
import { AddPolicyDataService } from './../../../../../../_services/signup-process-service/add-policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, PolicyErrorSvgComponent, MapfreInfoDivsComponent, MapfreButtonComponent, MapfreLinkComponent],
  selector: 'app-policy-not-found',
  templateUrl: './policy-not-found.component.html',
})
export class PolicyNotFoundComponent implements OnInit {
  userData: any = {};
  amountOfTries: number;
  policyHolderName: string;
  policyNumber: string;
  isAcmic: boolean;
  constructor(
    private addPolicyDataService: AddPolicyDataService,
    public router: Router,
    private acmicService: AcmicService
  ) {}

  onTryAgain(): void {
    this.userData.addPolicyAttempts = this.userData.addPolicyAttempts + 1;
    this.addPolicyDataService.updateAddPolicy(this.userData);
  }

  onRedirectContact() {
    this.router.navigate(['/contact']);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.addPolicyDataService.$newPolicy.subscribe((userData) => {
      this.policyHolderName = `${userData.userDetails.firstName} ${
        userData.userDetails.middleName === 'DEFAULT' ||
        userData.userDetails.middleName === ' '
          ? ''
          : userData.userDetails.middleName || ''
      } ${userData.userDetails.lastName}`;
      this.policyNumber = `${userData.policyDetail.policynumber.policyNumber}`;
      this.userData = userData;
      this.userData.addPolicyAttempts = userData.addPolicyAttempts || 0;
    });
  }


}
